"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.csn = void 0;
function csn(...classes) {
    return classes
        .map((item) => {
        if (item) {
            if (typeof item === 'object') {
                if (Array.isArray(item)) {
                    if (item[0] && item[1]) {
                        return item[0];
                    }
                }
                else {
                    return Object.keys(item)
                        .filter((key) => item[key])
                        .join(' ');
                }
            }
            else {
                return item;
            }
        }
        return '';
    })
        .filter((item) => item)
        .join(' ');
}
exports.csn = csn;
